/**
 * Service for managing tenant apps library (gridapps)
 */export class TenantAppsLibraryService{constructor(api){this.api=void 0;this.api=api;}/**
   * Get all gridapps for a tenant
   */async getTenantGridapps(tenantId){return this.api.get('/api/gridapps/developer',{organizationId:tenantId});}/**
   * Get a single gridapp by ID
   */async getGridapp(gridappId){return this.api.get(`/api/gridapps/${gridappId}`);}/**
   * Create a new gridapp
   */async createGridapp(data){return this.api.post('/api/gridapps',data);}/**
   * Update a gridapp
   */async updateGridapp(gridappId,data){return this.api.put(`/api/gridapps/${gridappId}`,data);}/**
   * Delete a gridapp
   */async deleteGridapp(gridappId){await this.api.delete(`/api/gridapps/${gridappId}`);}}